/*
 * @Author: Dong
 * @Date: 2022-04-29 13:39:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-09-08 14:57:03
 */
import React, { useEffect } from 'react';
import { MessageDescriptor } from 'react-intl';
import { Form, Input } from 'sup-ui';
import styles from './Form.less';
import { useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';
import messages from './messages';
import { useIntl } from 'react-intl';

interface propsType {
  name: string;
  dataSource: { name: string; label: MessageDescriptor; type: any; rules?: any[]; placeholder?: string }[];
  form: any;
  version: string;
  id: string;
}

const formItemLayout = {
  labelCol: {
    sm: { span: 24 },
  },
  wrapperCol: {
    sm: { span: 24 },
  },
};

const FormComponent = (props: propsType) => {
  const intl = useIntl();

  const { form, name, dataSource, id } = props;

  const { getFieldDecorator } = form;
  const { formData } = useSelector((state: reducerStates) => state.fileConfig);

  // 收集上传列表中的个性化表单配置
  useEffect(() => {
    if (!window.moduleForms) {
      window.moduleForms = {};
    }
    window.moduleForms[id] = form;
    return () => {
      delete window.moduleForms[id];
    };
  }, []);

  return (
    <div>
      <div className={styles.division}>
        <span className={styles.text}>{intl.formatMessage(messages.config)}</span>
        <span className={styles.line} />
      </div>
      <Form className={styles.form} {...formItemLayout}>
        {dataSource.map((item) => {
          const rules: any[] = item.rules
            ? item.rules.map((rule) => {
                return { ...rule, message: rule.message };
              })
            : [];
          const { placeholder } = item;
          return (
            <Form.Item key={item.name} label={item.label}>
              {getFieldDecorator(item.name, {
                initialValue: formData?.[name]?.[item.name],
                rules: rules,
              })(<Input size="small" placeholder={placeholder} />)}
            </Form.Item>
          );
        })}
      </Form>
    </div>
  );
};

export default Form.create()(FormComponent);
